export default {
  appName: 'Admin',
  login: 'Log in',
  logout: 'Log out',
  loading: 'Loading…',
}
